export const Impressum_DE = {
  entries: [
    [
      'Text',
      <>
        <a href='mailto:christof.gertsch@dasmagazin.ch?subject=Das%20Ende%20vom%20eigen%20Eis'>
          Christof Gertsch
        </a>{' '}
        &{' '}
        <a href='mailto:mikael.krogerus@dasmagazin.ch?subject=Das%20Ende%20vom%20eigen%20Eis'>
          Mikael Krogerus
        </a>
        , Das Magazin
      </>,
    ],
    ['Porträtbilder', 'Nora Lorek, Acacia Johnson, Michael Kohls'],
    [
      'Bildredaktion',
      <>
        Carmen Brunner & Maria Leutner, Das Magazin
        <br /> Boris Müller, Tamedia Editorial Services
      </>,
    ],
    [
      'Videos',
      <>
        Adrian Panholzer & Nicolas Fäs, Tamedia Video
        <br />
        mit Grafiken von Sarah Sbalchiero
      </>,
    ],
    ['Schlussredaktion', 'Severin Bruttin, Das Magazin'],
    ['Podcast', 'Mirja Gabathuler, Laura Bachmann, Vivienne Kuster'],
    // ['Übersetzung', 'Olivia Beuchat'],
    [
      'Umsetzung, Karten, Visualisierungen',
      'Sebastian Broschinski, Interaktiv-Team',
    ],
  ],
}
export const Impressum_FR = {
  entries: [
    [
      'Texte',
      <>
        <a href='mailto:christof.gertsch@dasmagazin.ch?subject=Das%20Ende%20vom%20eigen%20Eis'>
          Christof Gertsch
        </a>{' '}
        &{' '}
        <a href='mailto:mikael.krogerus@dasmagazin.ch?subject=Das%20Ende%20vom%20eigen%20Eis'>
          Mikael Krogerus
        </a>
        , Das Magazin
      </>,
    ],
    ['Portraits', 'Nora Lorek, Acacia Johnson, Michael Kohls'],
    [
      'Responsables des photos',
      <>
        Carmen Brunner & Maria Leutner, Das Magazin
        <br /> Boris Müller, Tamedia Editorial Services
      </>,
    ],
    [
      'Vidéos',
      <>
        Adrian Panholzer & Nicolas Fäs, Tamedia Video
        <br />
        avec des graphiques de Sarah Sbalchiero
      </>,
    ],
    ['Rédaction finale', 'Severin Bruttin, Das Magazin'],
    ['Traduction', 'Olivia Beuchat'],
    [
      'Réalisation, cartes, visualisations',
      'Sebastian Broschinski, Interaktiv-Team',
    ],
  ],
}
